module.exports = __webpack_public_path__ + "img/ic_light.fe3eba0f.svg";